import { themeV2 } from '@features/executive-report/domain/theme-v2';
import { ShapeProps } from '@features/powerpoint';

export const cardBackground = (
  layout: Pick<ShapeProps['options'], 'h' | 'w' | 'x' | 'y'>
): ShapeProps => ({
  shapeName: 'roundRect',
  options: {
    ...layout,
    fill: { type: 'solid', color: themeV2.colors.white },
    rectRadius: 0.05,
    shadow: {
      type: 'outer',
      color: '000000',
      opacity: 0.1,
      blur: 4,
      angle: 90,
      offset: 2,
    },
  },
});
